import {
  ChargingSpeedTypes,
  CurrentTypes,
  DateFiltersEnum,
  SelectOption,
} from "@/@types";
import { PartnershipInfraOwner } from "@/@types/dtos/partnerships.types";
import { SessionStatuses } from "@/domain/entities";

export const CurrentTypeOptions: SelectOption[] = [
  {
    value: CurrentTypes.AC,
    label: "AC",
  },
  {
    value: CurrentTypes.DC,
    label: "DC",
  },
];

export const ChargingSpeedTypeOptions: SelectOption[] = [
  {
    value: ChargingSpeedTypes.slow,
    label: "Carga normal (7 até 22kW)",
  },
  {
    value: ChargingSpeedTypes.fast,
    label: "Carga rápida (40 até 60kW)",
  },
  {
    value: ChargingSpeedTypes.ultra,
    label: "Carga ultra rápida (80 até 150kW)",
  },
];

export const ConnectorStatusOptions: SelectOption[] = [
  {
    value: "",
    label: "Todos",
    selected: true,
  },
  {
    value: "available",
    label: "Disponível",
    selected: false,
  },
  {
    value: "in_use",
    label: "Em uso",
    selected: false,
  },
  {
    value: "unavailable",
    label: "Indisponível",
    selected: false,
  },
];

export const SessionStatusesOptions: SelectOption[] = [
  {
    label: "Todos",
    value: "",
    selected: true,
  },
  {
    label: "Cancelado",
    value: SessionStatuses.canceled,
  },
  {
    label: "Em andamento",
    value: SessionStatuses.charging,
  },
  {
    label: "Finalizado",
    value: SessionStatuses.concluded,
  },
  {
    label: "Pendente",
    value: SessionStatuses.pending,
  },
];

export const DateFilterOptions: SelectOption[] = [
  {
    label: "Todo",
    value: DateFiltersEnum.all,
    selected: true,
  },
  {
    label: "Este mês",
    value: DateFiltersEnum.current_month,
  },
  {
    label: "Hoje",
    value: DateFiltersEnum.today,
  },
];

export const UFs: SelectOption[] = [
  { label: "Acre", value: "AC" },
  { label: "Alagoas", value: "AL" },
  { label: "Amapá", value: "AP" },
  { label: "Amazonas", value: "AM" },
  { label: "Bahia", value: "BA" },
  { label: "Ceará", value: "CE" },
  { label: "Distrito Federal", value: "DF" },
  { label: "Espírito Santo", value: "ES" },
  { label: "Goiás", value: "GO" },
  { label: "Maranhão", value: "MA" },
  { label: "Mato Grosso", value: "MT" },
  { label: "Mato Grosso do Sul", value: "MS" },
  { label: "Minas Gerais", value: "MG" },
  { label: "Pará", value: "PA" },
  { label: "Paraíba", value: "PB" },
  { label: "Paraná", value: "PR" },
  { label: "Pernambuco", value: "PE" },
  { label: "Piauí", value: "PI" },
  { label: "Rio de Janeiro", value: "RJ" },
  { label: "Rio Grande do Norte", value: "RN" },
  { label: "Rio Grande do Sul", value: "RS" },
  { label: "Rondônia", value: "RO" },
  { label: "Roraima", value: "RR" },
  { label: "Santa Catarina", value: "SC" },
  { label: "São Paulo", value: "SP" },
  { label: "Sergipe", value: "SE" },
  { label: "Tocantins", value: "TO" },
];

export const UnitOptions: SelectOption[] = [
  {
    value: "kwh",
    label: "Por kWh",
  },
  {
    value: "hour",
    label: "Por hora",
  },
];

export const ChargerCommandOptions: SelectOption[] = [
  {
    value: "ClearCache",
    label: "Limpar cache",
  },
  {
    value: "Reset",
    label: "Resetar",
  },
  {
    value: "UnlockConnector",
    label: "Desbloquear conector",
  },
  // {
  //   value: "RemoteStart",
  //   label: "Iniciar remotamente",
  // },
  // {
  //   value: "RemoteStop",
  //   label: "Encerrar remotamente",
  // },
  {
    value: "ChangeAvailability",
    label: "Alterar disponibilidade",
  },
];

export const ResetTypeOptions: SelectOption[] = [
  {
    value: "Hard",
    label: "Hard",
  },
  {
    value: "Soft",
    label: "Soft",
  },
];

export const AvailableTypeOptions: SelectOption[] = [
  {
    value: "Inoperative",
    label: "Inoperante",
  },
  {
    value: "Operative",
    label: "Operativo",
  },
];


export const InfraOptions: SelectOption[] = [
  {
    value: PartnershipInfraOwner.greezon,
    label: "Greezon",
  },
  {
    value: PartnershipInfraOwner.partner,
    label: "Parceiro",
  },
];